// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName___4Rr4","productName":"Table_productName__3s7SN"};